import { useEffect, useRef, useState } from "react";
import { BellOff, BellRing } from "lucide-react";
import { cleoApi } from "./api";

/**
 * Faixa de clientes esperando atendimento humano (quem a CLEO chamou um
 * atendente). Consulta a fila a cada 3 s e toca o som a cada 10 s enquanto
 * houver alguém. Some quando a fila está vazia.
 */
export default function FilaAtendimento() {
  const [fila, setFila] = useState([]);
  const audio = useRef(null);
  const laco = useRef(null);
  const filaRef = useRef([]);
  filaRef.current = fila;

  const parar = () => {
    if (audio.current) { audio.current.pause(); audio.current = null; }
    if (laco.current) { clearInterval(laco.current); laco.current = null; }
  };
  const tocar = () => {
    if (laco.current) return;
    const umaVez = () => {
      const a = new Audio(cleoApi.somFila);
      a.volume = 0.7;
      audio.current = a;
      a.onended = () => { audio.current = null; };
      a.play().catch(() => {});
    };
    umaVez();
    laco.current = setInterval(() => { if (!audio.current && filaRef.current.length) umaVez(); }, 10000);
  };

  useEffect(() => {
    let vivo = true;
    const olhar = async () => {
      try {
        const d = await cleoApi.fila();
        if (!vivo || !d?.success) return;
        setFila(d.queue || []);
        if (d.has_waiting) tocar(); else parar();
      } catch { /* sem rede: tenta de novo em 3 s */ }
    };
    olhar();
    const t = setInterval(olhar, 3000);
    return () => { vivo = false; clearInterval(t); parar(); };
  }, []);

  const ignorar = async (phone) => {
    await cleoApi.ignorar(phone).catch(() => {});
    setFila((f) => f.filter((c) => c.phone !== phone));
    if (fila.length <= 1) parar();
  };
  const ignorarTodos = async () => {
    await cleoApi.ignorarTodos().catch(() => {});
    setFila([]); parar();
  };

  if (!fila.length) return null;
  return (
    <div className="rounded-2xl border-2 border-red-500/60 bg-red-500/5 p-4">
      <div className="flex flex-wrap items-center gap-3">
        <BellRing className="h-5 w-5 animate-pulse text-red-500" />
        <p className="flex-1 font-semibold">
          {fila.length} cliente{fila.length === 1 ? "" : "s"} esperando atendimento humano
        </p>
        <button type="button" onClick={ignorarTodos}
          className="inline-flex items-center gap-1.5 rounded-lg border px-3 py-1.5 text-xs font-semibold hover:bg-muted">
          <BellOff className="h-3.5 w-3.5" /> Desligar notificação
        </button>
      </div>
      <ul className="mt-3 space-y-1.5">
        {fila.map((c) => (
          <li key={c.phone} className="flex items-center gap-3 rounded-lg bg-background px-3 py-2 text-sm">
            <span className="flex-1 min-w-0 truncate"><b>{c.name || c.push_name || "Cliente"}</b> · {c.phone}</span>
            <button type="button" onClick={() => ignorar(c.phone)} className="rounded-lg border px-2.5 py-1 text-xs font-medium hover:bg-muted">Ignorar</button>
          </li>
        ))}
      </ul>
    </div>
  );
}
